import { RateReview } from '@mui/icons-material';
import { Box } from '@mui/material';
import { CircleMinus, Download } from 'lucide-react';
import { useState } from 'react';
import { useRecoilState } from 'recoil';
import MenuItem from '~/components/Menu/MenuItem';
import SidebarActionMenu from '~/components/Menu/SidebarActionMenu';
import { StructureSet } from '~/domain/patient/structureset';
import { useDicomExport } from '~/hooks/export/useDicomExport';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import { reviewToolState } from '~/state/atoms/toolsAtoms';
import AvailableStructruesList from './AvailableStructuresList';

export default function StructuresActionMenu({
    currentStructureSet,
}: {
    currentStructureSet: StructureSet;
}) {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const { handleDownloadStructureSet } = useDicomExport();
    const { unloadStructureSet } = useViewportEnvironment();
    const [reviewToolOpen, setReviewToolOpen] = useRecoilState(reviewToolState);

    const handleStructureSetUnload = () => {
        setAnchorEl(null);
        unloadStructureSet();
    };

    return (
        <Box>
            <SidebarActionMenu anchorEl={anchorEl} setAnchorEl={setAnchorEl}>
                <AvailableStructruesList onSelect={() => setAnchorEl(null)} />
                <MenuItem
                    label="Review Tool"
                    onClick={() => {
                        setReviewToolOpen(!reviewToolOpen);
                        setAnchorEl(null);
                    }}
                    icon={<RateReview sx={{ fontSize: 16 }} />}
                />
                <MenuItem
                    label="Download"
                    onClick={() => {
                        handleDownloadStructureSet(currentStructureSet);
                        setAnchorEl(null);
                    }}
                    icon={<Download size={16} />}
                />
                <MenuItem
                    label="Unload"
                    onClick={() => {
                        handleStructureSetUnload();
                    }}
                    icon={<CircleMinus size={16} />}
                />
            </SidebarActionMenu>
        </Box>
    );
}
